(() => {
  const init = async () => {
    const root = document.querySelector('[data-gl-bracelets]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const incoming = new URL(location.href);
    const aliases = {'filter.p.m.custom.style':'style','filter.v.option.metal':'metal','filter.p.m.custom.metal1':'metal','filter.v.price.gte':'min','filter.v.price.lte':'max'};
    if ([...incoming.searchParams.keys()].some(k => k.startsWith('filter.') || k === 'page')) {
      Object.entries(aliases).forEach(([k,v]) => {if (incoming.searchParams.has(k)) incoming.searchParams.set('br_'+v,incoming.searchParams.get(k));});
      [...incoming.searchParams.keys()].filter(k => k.startsWith('filter.') || k === 'page').forEach(k => incoming.searchParams.delete(k));
      location.replace(incoming.href); return;
    }
    const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
    const grid = root.querySelector('[data-grid]');
    const form = root.querySelector('[data-filters]');
    const controls = Object.fromEntries([...root.querySelectorAll('[data-filter]')].map(el => [el.dataset.filter,el]));
    const money = n => new Intl.NumberFormat('en-GB',{style:'currency',currency:root.dataset.currency || 'GBP'}).format(n/100);
    const metal = raw => {
      const s=String(raw || '').replace(/(9|14|18)k\b/ig,'$1ct');
      if (/silver|sterling/i.test(s)) return /gold[ -]?(?:plated|on)|gold vermeil|vermeil/i.test(s) ? 'plated' : 'silver';
      if (/platinum/i.test(s)) return 'platinum';
      const m=s.match(/(9|14|18)\s*ct\s*(white|yellow|rose)\s*gold/i);
      return m ? m[2].toLowerCase()+m[1] : '';
    };
    const style = raw => {
      const rules=[['tennis',/tennis/i],['station',/station|by.the.yard/i],['infinity',/infinity/i],['clover',/clover/i],['evil_eye',/evil.eye/i],['halo',/halo/i],['heart',/heart/i],['circle',/circle/i],['solitaire',/solitaire/i],['identity',/identity|\bID\b/i],['bangle',/bangle|torque|cuff/i],['paperclip',/paperclip|paper.clip/i],['curb',/curb/i],['figaro',/figaro/i],['rope',/rope/i],['belcher',/belcher/i],['chain',/chain/i]];
      return rules.find(([,pattern]) => pattern.test(raw))?.[0] || 'fancy';
    };
    const weightBand = n => n<=0 ? '' : n<0.5 ? 'under05' : n<1 ? '05to1' : n<2 ? '1to2' : n<4 ? '2to4' : n<6 ? '4to6' : '6plus';
    const shape = raw => {
      const s=String(raw || '').toLowerCase();
      const values=Object.keys(labels.shapes).filter(v => s.includes(v));
      return values.length>1 || /mixed/i.test(s) ? 'mixed' : values[0] || '';
    };
    const type = raw => /lab|CVD|HPHT/i.test(raw) && /diamond/i.test(raw) ? 'lab' : /natural/i.test(raw) && /diamond/i.test(raw) ? 'natural' : /diamond/i.test(raw) ? 'diamond' : /cubic|zirconia|\bCZ\b/i.test(raw) ? 'cz' : /amber/i.test(raw) ? 'amber' : 'plain';
    let nodes=[...grid.querySelectorAll('[data-product]')];
    let next=root.dataset.next;
    let loadFailed=false;
    form.setAttribute('aria-busy','true');
    try {
      const visited=new Set();
      while (next && !visited.has(next)) {
        visited.add(next);
        const response=await fetch(next,{credentials:'same-origin'});
        if (!response.ok) throw new Error('collection');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const page=doc.querySelector('[data-gl-bracelets]');
        if (!page) throw new Error('collection');
        const extra=[...page.querySelectorAll('[data-product]')];
        grid.append(...extra); nodes.push(...extra); next=page.dataset.next;
      }
    } catch (_) {loadFailed=true;}
    const seen=new Set();
    const products=nodes.filter(el => {if(seen.has(el.dataset.id)){el.remove();return false;}seen.add(el.dataset.id);return true;}).map((el,index) => {
      const d=el.dataset;
      const title=d.title || '';
      const stoneType=type(d.type+' '+title);
      const titleWeight=title.match(/^\s*(\d+(?:\.\d+)?)\s*ct\s+(?:Lab|Natural|Diamond)/i);
      const weight=Number(d.weight) || Number(titleWeight?.[1]) || 0;
      const variants=JSON.parse(el.querySelector('[data-variants]').textContent).map(v => ({...v,price:Number(v.price),weight:Number(v.weight)||weight,metal:metal(v.metal)||metal(title)||metal(d.metal)}));
      const length=Number.parseFloat(d.length);
      return {el,index,title,type:stoneType,style:style(title+' '+(d.style || '')),shape:shape(d.shape)||shape(title),length:length>0 && length<=12 ? String(length) : '',variants,created:Number(d.created)};
    });
    const addOptions=(key,values,group) => {
      values.forEach(v => controls[key].add(new Option(group?.[v] || v,v)));
      const facet=root.querySelector('[data-facet="'+key+'"]');
      if(facet) facet.hidden=values.length<2;
    };
    const unique=values => [...new Set(values.filter(Boolean))];
    addOptions('style',unique(products.map(p=>p.style)).sort((a,b)=>labels.styles[a].localeCompare(labels.styles[b])),labels.styles);
    addOptions('type',Object.keys(labels.types).filter(t=>products.some(p=>p.type===t)),labels.types);
    addOptions('metal',Object.keys(labels.metals).filter(m=>products.some(p=>p.variants.some(v=>v.metal===m))),labels.metals);
    addOptions('shape',Object.keys(labels.shapes).filter(s=>products.some(p=>p.shape===s)),labels.shapes);
    addOptions('weight',Object.keys(labels.weights).filter(w=>products.some(p=>p.type!=='plain' && /lab|natural|diamond/.test(p.type) && p.variants.some(v=>weightBand(v.weight)===w))),labels.weights);
    addOptions('length',unique(products.map(p=>p.length)).sort((a,b)=>Number(a)-Number(b)));
    addOptions('availability',['yes','no'].filter(a=>products.some(p=>p.variants.some(v=>Boolean(v.available)===(a==='yes')))),labels.availability);
    const restore=() => {
      const params=new URLSearchParams(location.search);
      Object.entries(controls).forEach(([k,el])=>{
        let value=params.get('br_'+k) || (k==='sort'?'featured':'');
        if(k==='metal' && value && !labels.metals[value]) value=metal(value);
        if(k==='style' && value && !labels.styles[value]) value=style(value);
        el.value=value;
      });
    };
    restore();
    let limit=24;
    const variantsFor=(p,s)=>p.variants.filter(v=>(!s.metal || v.metal===s.metal) && (s.min==='' || v.price>=Number(s.min)*100) && (s.max==='' || v.price<=Number(s.max)*100) && (!s.weight || /lab|natural|diamond/.test(p.type) && weightBand(v.weight)===s.weight) && (!s.availability || Boolean(v.available)===(s.availability==='yes')));
    const selectedFor=(p,s)=>{const v=variantsFor(p,s);return v.filter(v=>v.available).sort((a,b)=>a.price-b.price)[0] || v.sort((a,b)=>a.price-b.price)[0];};
    const update=(writeUrl=true)=>{
      const s=Object.fromEntries(Object.entries(controls).map(([k,el])=>[k,el.value]));
      const matches=products.filter(p=>(!s.style || p.style===s.style) && (!s.type || p.type===s.type) && (!s.shape || p.shape===s.shape) && (!s.length || p.length===s.length) && variantsFor(p,s).length);
      const price=p=>selectedFor(p,s).price;
      matches.sort((a,b)=>s.sort==='price-low'?price(a)-price(b):s.sort==='price-high'?price(b)-price(a):s.sort==='newest'?b.created-a.created:a.index-b.index);
      products.forEach(p=>{p.el.hidden=true;});
      matches.slice(0,limit).forEach(p=>{
        p.el.hidden=false;
        const v=selectedFor(p,s);
        p.el.querySelectorAll('[data-product-link]').forEach(a=>{a.href=p.el.dataset.url+'?variant='+v.id;});
        const image=p.el.querySelector('img');
        if(image && v.image && image.dataset.variantImage!==v.image){image.src=v.image;image.removeAttribute('srcset');image.dataset.variantImage=v.image;}
        const prices=variantsFor(p,s).map(v=>v.price);
        p.el.querySelector('[data-card-price]').textContent=(Math.min(...prices)!==Math.max(...prices)?labels.cards.from+' ':'')+money(Math.min(...prices));
        p.el.querySelector('[data-card-metal]').textContent=s.metal?labels.metals[s.metal]:unique(p.variants.map(v=>labels.metals[v.metal])).join(' / ');
        p.el.querySelector('[data-kicker]').textContent=p.type==='plain'?'':labels.types[p.type];
        let badge=p.el.querySelector('.glp-status');
        if(!v.available){if(!badge){badge=document.createElement('span');badge.className='glp-status';badge.textContent=labels.cards.unavailable;p.el.querySelector('.gle-card-image').append(badge);}}else if(badge)badge.remove();
      });
      grid.append(...matches.map(p=>p.el));
      const count=root.querySelector('[data-count]');
      count.textContent=loadFailed?labels.results.error:count.dataset.template.replace('__count__',matches.length);
      root.querySelector('[data-empty]').hidden=matches.length!==0;
      root.querySelector('[data-more]').hidden=matches.length<=limit;
      const showing=root.querySelector('[data-showing]');
      showing.textContent=matches.length?showing.dataset.template.replace('__shown__',Math.min(limit,matches.length)).replace('__total__',matches.length):'';
      const retry=root.querySelector('[data-retry]');retry.hidden=!loadFailed;if(next)retry.href=next;
      const active=root.querySelector('[data-active]');active.replaceChildren();
      Object.entries(s).filter(([key,value])=>value && key!=='sort').forEach(([key,value])=>{
        const control=controls[key];
        const text=control.tagName==='SELECT'?control.selectedOptions[0]?.textContent:(key==='min'?'≥ ':'≤ ')+money(Number(value)*100);
        const b=document.createElement('button');b.type='button';b.textContent=text+' ×';b.setAttribute('aria-label',labels.filters.remove+' '+text);
        b.addEventListener('click',()=>{control.value='';limit=24;update();});active.append(b);
      });
      if(writeUrl){const url=new URL(location.href);url.searchParams.delete('sort_by');Object.entries(s).forEach(([k,v])=>{if(v && !(k==='sort' && v==='featured'))url.searchParams.set('br_'+k,v);else url.searchParams.delete('br_'+k);});history.replaceState(null,'',url);}
    };
    form.removeAttribute('aria-busy');
    form.addEventListener('submit',e=>{e.preventDefault();limit=24;update();});
    Object.values(controls).forEach(el=>el.addEventListener('change',()=>{limit=24;update();}));
    [controls.min,controls.max].forEach(el=>el.addEventListener('input',()=>{limit=24;update();}));
    root.querySelectorAll('[data-reset]').forEach(b=>b.addEventListener('click',()=>{Object.entries(controls).forEach(([k,el])=>{el.value=k==='sort'?'featured':'';});limit=24;update();}));
    root.querySelector('[data-more]').addEventListener('click',()=>{limit+=24;update(false);});
    root.querySelector('[data-filter-toggle]').addEventListener('click',event=>{const open=form.classList.toggle('is-open');event.currentTarget.setAttribute('aria-expanded',String(open));});
    addEventListener('popstate',()=>{restore();limit=24;update(false);});
    update(false);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
